import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('delta3series.recycling');
    const { locale } = useRouter();

    return <div className={styles.TheComp}>{t('B_text')}</div>;
}
